import React, {Component} from 'react';
import 'loader-blocks.gif';
const Loader = props => (
  <div className="loader small-12 cell text-center">
    <img src={require(`loader-blocks.gif`)}/>
  </div>
);
export default Loader
